const cpapFollowUpData = {
  sleepStudyNumber: "",
  firstName: "",
  lastName: "",
  dateOfBirth: "",
  age: "",
  mobile: "",
  email: "",
  startCpapDate: "",
  typeOfCpap: "",
  brand: "",
  minPressure: "",
  maxPressure: "",
  currentRampTime: "",
  humidifierSystem: "",
  averageLeak: "",
  maskType: "",
  maskSize: "",
  maskBrand: "",
  sleepTestResult: "",
  diagnosticAHI: "",
  preTreatmentEssScore: "",
  visitNumber: "",
  followupDate: "",
  followupType: "",
  cpapDataPeriod: "",
  cpapDataTotalDays: "",
  compliantDaysPct: "",
  avgUsageHours: "",
  avgAhi: "",
  pressure95Pct: "",
  maskLeakRate: "",
  assessment: "",
  essScore: "",
  wakeUpFeeling: "",
  daytimeSleepiness: "",
  problems: "",
  assessmentSummary: "",
  recommendations: "",
  nextAppointment: "",
};

export default cpapFollowUpData;
